import { createIntl, createIntlCache } from "react-intl";
import { toast } from "react-toastify";
import data from "../../i18n/messages/en.json";

const cache = createIntlCache();
const allerrormessage = {};
const fetchData = async () => {
  for (const key in data) {
    if (key.startsWith("API.ERROR")) {
      allerrormessage[key] = data[key];
    }
  }
};

const intl = createIntl(
  {
    locale: "en",
    messages: allerrormessage,
  },
  cache,
);

export const HandleApiError = (e: any) => {
  fetchData();
  const translatedMessage = intl.formatMessage({
    id: `API.ERROR.${e?.response?.data?.msg}`,
    defaultMessage: "",
  });

  if (translatedMessage?.includes("API.ERROR")) {
    if (process.env.NODE_ENV === "development") {
      toast.error(e.message || translatedMessage);
    }
    return;
  } else {
    toast.error(translatedMessage);
  }
};
